var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HistoryTabTemplate',{attrs:{"items":_vm.items,"loading":_vm.loading}},_vm._l((_vm.items),function(item,itemIndex){return _c('CommentCard',{key:`org-comment-${itemIndex}`,attrs:{"data-qa":`org-comment-${itemIndex}`,"item":item,"text-button":item.needBadge ? _vm.$t('Common.Answer') : null},on:{"openChat":val => _vm.$emit('openChat', val)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }